import React from "react";
import { useTranslation } from "react-i18next";

type Props = {
  show: boolean;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  className?: string;
  id?:string;
};

export const LanguageSelector: React.FC<Props> = ({ show, value, onChange, className, id }) => {
    const { t } = useTranslation();
  if (!show) return null;

  return (
    <select
      id={id}
      className={className ?? "language-selector"}
      value={value}
      onChange={onChange}
      aria-label="Language selector"
    >
      <option value="en">{t("language_selector_english")}</option>
      <option value="dk">{t("language_selector_danish")}</option>
    </select>
  );
};
